import { render, staticRenderFns } from "./ToolbarColor.vue?vue&type=template&id=89341920&"
import script from "./ToolbarColor.vue?vue&type=script&lang=js&"
export * from "./ToolbarColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports